import { CreateInvestmentPayload } from '../redux/types/invest'
import BaseRequest from './index'

class InvestServices extends BaseRequest {
  constructor() {
    super()
    this.bindMethods()
  }

  bindMethods() {
    this.getAllInvestments = this.getAllInvestments.bind(this)
    this.createInvestment = this.createInvestment.bind(this)
    this.getUserInvestments = this.getUserInvestments.bind(this)
  }

  async getAllInvestments<T>(): Promise<T> {
    return this.api.get('/investment/plans')
  }
  async getUserInvestments<T>(): Promise<T> {
    return this.api.get('/user/investment/plans')
  }

  async createInvestment<T>(data: CreateInvestmentPayload): Promise<T> {
    return this.api.post('/user/investment/invest', {
      ...data,
      device: 'web',
    })
  }
}

const investServices = new InvestServices()

export default investServices
